import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";

var _types$UPDATE_HOROSCO;

import * as types from "@/store/constants/types";
import { horoscopeTimeList } from "@/utils/horoscopeUtil";
export default (_types$UPDATE_HOROSCO = {}, _defineProperty(_types$UPDATE_HOROSCO, types.UPDATE_HOROSCOPE, function (state, payLoad) {
  if (state.horoscope !== payLoad) {
    state.horoscope = payLoad;
    state.horoScopeTime = horoscopeTimeList[payLoad];
  }
}), _defineProperty(_types$UPDATE_HOROSCO, types.UPDATE_TODAY_HOROSCOPE_FATE, function (state, payLoad) {
  state.todayHoroscopeFate = payLoad;
}), _defineProperty(_types$UPDATE_HOROSCO, types.UPDATE_TOMORROW_HOROSCOPE_FATE, function (state, payLoad) {
  state.tomorrowHoroscopeFate = payLoad;
}), _defineProperty(_types$UPDATE_HOROSCO, types.UPDATE_WEEK_HOROSCOPE_FATE, function (state, payLoad) {
  state.weekHoroscopeFate = payLoad;
}), _defineProperty(_types$UPDATE_HOROSCO, types.UPDATE_MONTH_HOROSCOPE_FATE, function (state, payLoad) {
  state.monthHoroscopeFate = payLoad;
}), _defineProperty(_types$UPDATE_HOROSCO, types.UPDATE_YEAR_HOROSCOPE_FATE, function (state, payLoad) {
  state.yearHoroscopeFate = payLoad;
}), _defineProperty(_types$UPDATE_HOROSCO, types.UPDATE_DAILY_PLAMISTRY_DATA, function (state, payload) {
  state.dailyPlamistryData = payload;
}), _types$UPDATE_HOROSCO);